import mediaData from "@/i18n/json/media/data.json"
import {radioContainer, radioImg, radioItem, radioTitle, radioContent} from "./style";
import {useTranslation, Trans} from "react-i18next";

const RadioItems = () => {
    const radioInterviews = [...mediaData["radio-interviews"]]
    const {t} = useTranslation()
    return <div className={radioContainer}>
        {radioInterviews.map((item, index) => {
            return <a href={item.source} target={"_blank"} key={index}>
                <div className={radioItem}>
                    <img className={radioImg} src={`/assets/images/media/radio/${item.img}`}
                         alt={t(`media.radio-interview-section.radio-interviews.${index}.img.alt`)}
                         title={t(`media.radio-interview-section.radio-interviews.${index}.img.title`)}/>
                    <div>
                        <p className={radioTitle}>
                            <Trans components={{sup: <sup/>}}>{`media.radio-interview-section.radio-interviews.${index}.title`}</Trans>
                        </p>
                        <p className={radioContent}>{item.participants}</p>
                        <p className={radioContent}>{item.host}</p>
                        <p className={radioContent}>{t(`media.radio-interview-section.radio-interviews.${index}.date_time`)}</p>
                    </div>
                </div>
            </a>
        })}
    </div>
}

export default RadioItems